module.exports = __webpack_public_path__ + "img/logo-white.8d9c465a.png";